import Cookies from 'js-cookie';
import { call, put, takeEvery, all } from 'redux-saga/effects';

import { customerId } from 'common/helpers/tokenHelper';
import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';
import { LIST_CLUB_MEMBER_SHIPMENTS_SUCCESS } from 'redux/clubMemberShipments/constants';
import { GET_CLUB_MEMBERSHIP_SUCCESS } from 'redux/clubMemberships/constants';
import { getClubPackage } from 'redux/clubPackages/api';
import { LIST_CLUB_PACKAGES_SUCCESS } from 'redux/clubPackages/constants';
import { LIST_CLUB_SUBSCRIPTION_SHIPMENTS_SUCCESS } from 'redux/clubSubscriptionShipments/constants';
import { LIST_CLUBS_SUCCESS } from 'redux/clubs/constants';
import { listPayload as listProductPayload } from 'redux/products/sagas';

import { getPersonalizationBlock } from './api';
import {
  GET_PERSONALIZATION_CONTENT_REQUEST,
  GET_PERSONALIZATION_CONTENT_SUCCESS,
  PERSONALIZATION_CONTENT_OBJECT_REQUESTING,
  RESET_PERSONALIZATION_CONTENT_ISFETCHING
} from './constants';

function* get(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: PERSONALIZATION_CONTENT_OBJECT_REQUESTING });
    const response = yield call(
      getPersonalizationBlock,
      action.code,
      cartId(),
      customerId()
    );

    yield put({
      type: GET_PERSONALIZATION_CONTENT_SUCCESS,
      payload: response.data
    });
    if (response.data.type === 'Product Collection') {
      yield call(listProductPayload, response.data.data);
    }
    if (response.data.type === 'Club Shipment') {
      yield call(listClubMembershipPayload, response.data.data);
    }
  } catch (error) {
    yield put({ type: RESET_PERSONALIZATION_CONTENT_ISFETCHING });
    if (action.onError) {
      action.onError(error);
    } else {
      yield call(addAPIError, error);
    }
  }
}

function* updateClubs(clubMemberships) {
  const clubs = [];
  clubMemberships.forEach((clubMembership) => {
    if (clubMembership.club) {
      clubs.push(clubMembership.club);
    }
  });
  yield put({
    type: LIST_CLUBS_SUCCESS,
    payload: { data: clubs }
  });
}

function* updateClubSubscriptionShipments(clubSubscriptionShipment) {
  const clubSubscriptionShipments = [];

  if (clubSubscriptionShipment) {
    clubSubscriptionShipments.push(clubSubscriptionShipment);
  }

  yield put({
    type: LIST_CLUB_SUBSCRIPTION_SHIPMENTS_SUCCESS,
    payload: { clubSubscriptionShipments }
  });
}

function* updateClubPackages(clubPackage) {
  const clubPackages = [];

  if (clubPackage) {
    clubPackages.push(clubPackage);
  }

  yield put({
    type: LIST_CLUB_PACKAGES_SUCCESS,
    payload: { clubPackages }
  });
  return { clubPackages };
}

function* updateClubMemberShipments(clubMemberShipment) {
  const clubMemberShipments = [];
  if (clubMemberShipment) {
    clubMemberShipments.push(clubMemberShipment);
  }
  yield put({
    type: LIST_CLUB_MEMBER_SHIPMENTS_SUCCESS,
    payload: { clubMemberShipments }
  });
}

const transformMembership = (
  clubMembership,
  clubSubscriptionShipment,
  clubMemberShipment,
  clubPackage
) => {
  const newMembership = clubMembership;

  if (clubPackage) {
    newMembership.activeClubPackageId = clubPackage.id;
    delete newMembership.clubPackage;
  }
  if (clubMemberShipment) {
    newMembership.activeClubMemberShipmentId = clubMemberShipment.id;
    delete newMembership.clubMemberShipment;
  }
  if (clubSubscriptionShipment) {
    newMembership.activeClubSubscriptionShipmentId =
      clubSubscriptionShipment.id;
    delete newMembership.clubSubscriptionShipment;
  }
  return newMembership;
};

function* listClubMembershipPayload(payload) {
  yield call(updateClubs, [payload.clubMembership]);

  let clubPackagesResult = null;

  if (payload.clubType === 'Subscription') {
    yield call(
      updateClubSubscriptionShipments,
      payload.clubSubscriptionShipment
    );
  }
  if (payload.clubType === 'Traditional') {
    yield call(updateClubMemberShipments, payload.clubMemberShipment);
    clubPackagesResult = yield call(
      getClubPackage,
      payload.clubMemberShipment.clubPackageId
    );

    yield call(updateClubPackages, clubPackagesResult.data);
  }

  const transformedMemberships = transformMembership(
    payload.clubMembership,
    payload.clubSubscriptionShipment,
    payload.clubMemberShipment,
    clubPackagesResult?.data
  );

  yield put({
    type: GET_CLUB_MEMBERSHIP_SUCCESS,
    payload: transformedMemberships
  });
}

function* watchList() {
  // Need take every so that gets multiple collections on a page
  yield takeEvery(GET_PERSONALIZATION_CONTENT_REQUEST, get);
}

export default function* personalizationBlockSagas() {
  yield all([watchList()]);
}

const cartId = () => Cookies.get('cartId');
